import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'

Vue.use(Router)

import posport from './modules/passport'
import indexPage from './modules/indexPage'
import system from './modules/system'
import order from './modules/order'
import warehouse from './modules/warehouse'
import integralRouter from './modules/integralRouter'
import mallRouter from './modules/mallRouter'
import goodsRouter from './modules/goodsRouter'
import { back_url } from '@/utils/commonValue'

import store from "@/store/index"

const router = new Router({
  mode: "history",
  routes: posport.concat(indexPage).concat(system).concat(mallRouter).concat(order).concat(integralRouter).concat(warehouse).concat(goodsRouter)
    .concat([
      {
        path: '/error',
        component: () => import('@/views/error/500'),
        name: 'error500',
        meta: { title: '后台', icon: '', affix: true }
      }
    ])
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  const not_need_login_name = ['login', 'saleBoardIndex']
  if (not_need_login_name.indexOf(to.name) > -1) {
    next();
    return;
  }

  var token = Cookies.get('_ctx')
  if (token) {
    next()
    return
  } else {
    next({ path: '/passport/login' + (to.name == 'indexPage' ? '' : '?isIfreme=1') });
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js